import { didRestore } from '../../../redux/actions/auth';
import { bindConnect } from '../../../utils';
import Restore from './Restore';

export default bindConnect(() => ({}), {
  didRestore
})(Restore);
